export default function Slider() {
  return <div className="slider"></div>;
}
